import * as React from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Input, InputProps } from "antd";
import { t } from "i18next";
import { classNames } from "src/common/classNames";
import styles from "./PlmInputSearch.module.less";

export const PlmInputSearch: React.FC<InputProps> = ({
  className,
  ...props
}) => (
  <Input
    {...props}
    className={classNames([styles.input, className])}
    prefix={<SearchOutlined />}
    placeholder={t("Search")}
    allowClear
  />
);
